import React, { useContext, useRef } from 'react'
import { useEffect, useState } from 'react'
import { Input, Select, Modal, Form, Button, Typography, Table, Popconfirm, notification } from 'antd'
import { observer } from 'mobx-react-lite'
import { GLOBAL_CLIENT } from '../../helpers/GlobalClient'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../hooks'
import styled from 'styled-components'
import { PlusOutlined } from '@ant-design/icons'
import type { FormInstance } from 'antd/es/form'
import { debounce, size } from 'lodash'
import { formatCurrency, showMessageError } from 'src/helpers/functions'
import { getStatusOrder, DATE_TIME_FORMAT_CLIENT_short, DELIVERY_CONST, GKE_SERVICES } from 'src/helpers/constants'
import moment from 'moment'
import { Loading } from 'src/common'

const formItemLayout = {
   labelCol: {
      xs: { span: 24 },
      sm: { span: 8 }
   },
   wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 }
   }
}

export const ModalWrapper = styled.div`
   .ant-table::-webkit-scrollbar {
      width: 8px;
      /* width of the entire scrollbar */
   }

   // .ant-table-content::-webkit-scrollbar-track {
   //    background: orange;
   //    /* color of the tracking area */
   // }

   // .ant-table-content::-webkit-scrollbar-thumb {
   //    background-color: blue;
   //    /* color of the scroll thumb */
   //    border-radius: 20px;
   //    /* roundness of the scroll thumb */
   //    border: 3px solid orange;
   //    /* creates padding around scroll thumb */
   // }
   .editable-cell {
      position: relative;
   }

   .editable-cell-value-wrap {
      padding: 5px 12px;
      cursor: pointer;
   }

   .editable-row:hover .editable-cell-value-wrap {
      padding: 4px 11px;
      border: 1px solid #d9d9d9;
      border-radius: 2px;
   }

   [data-theme='dark'] .editable-row:hover .editable-cell-value-wrap {
      border: 1px solid #434343;
   }
`
const UpdateStatusFF = observer((props: any) => {
   const { t } = useTranslation()

   const { item: data, visible, onOk, onCancel, onlyView } = props
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   const UserStore = useStore('UserStore')
   const OrdersStore = useStore('OrdersStore')
   const [form] = Form.useForm()
   const [loading, setLoading] = useState(false)
   const [selectedDelivery, setSelectedDelivery] = useState<string>()

   const onFinish = async (values: any) => {
      setLoading(true)

      const formData: any = {
         statusFF: values.statusFF,
         ids: data?.map((o: any) => o.id)
      }

      const result = await OrdersStore.updateStatusOrders(formData.ids, formData.statusFF)

      if (result) {
         notification.open({
            message: 'Thông báo',
            description: `Cập nhật trạng thái FF ${formData.statusFF || ''} thành công!`,
            type: 'success',
            placement: 'topRight'
         })
         onOk()
         form.resetFields()
         setSelectedDelivery(undefined)
      }

      setLoading(false)
   }

   return (
      <Modal
         width={'60%'}
         style={{ maxWidth: '1200px' }}
         visible={visible}
         centered
         title={'Cập nhật status FF'}
         okText={'Gửi'}
         cancelText={t(GLOBAL_CLIENT.close)}
         onCancel={onCancel}
         onOk={form.submit}
      >
         <ModalWrapper>
            <Loading isLoading={loading}></Loading>
            <Form
               {...formItemLayout}
               form={form}
               name="UpdateStatusFF"
               onFinish={debounce(onFinish, 400)}
               scrollToFirstError
            >
               <div style={{ marginBottom: '10px' }}></div>
               <Form.Item labelAlign="left" name="statusFF" label={'Trạng thái FF'} required>
                  <Select
                     placeholder="Chọn trạng thái FF"
                     onChange={(val: any) => {
                        setSelectedDelivery(val)
                        form.setFieldsValue({ service: undefined }) // reset nếu chuyển sang DVVC khác
                     }}
                  >
                     <Select.Option key={''} value={''}>
                        {''}
                     </Select.Option>
                     {((UserStore?.listConfigFF || '').split(',') || []).map((item: any) => {
                        return (
                           <Select.Option key={item} value={item}>
                              {item}
                           </Select.Option>
                        )
                     })}
                  </Select>
               </Form.Item>
            </Form>
         </ModalWrapper>
      </Modal>
   )
})

export default UpdateStatusFF
